export const disableArea = [
  '',
  `mutation disableArea($id:Int!) {
      disableArea(id:$id)
    }
  `,
  'disableArea'];
